/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Pain_HistoricalInputs */

const en_us2_profile_pain_historical = /** @type {(inputs: Profile_Pain_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past injury, no pain now`)
};

const pt_br2_profile_pain_historical = /** @type {(inputs: Profile_Pain_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já teve, não dói mais`)
};

const es_419_profile_pain_historical = /** @type {(inputs: Profile_Pain_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesión pasada, sin dolor ahora`)
};

const pt_pt2_profile_pain_historical = /** @type {(inputs: Profile_Pain_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já tiveste, já não dói`)
};

const fr_fr2_profile_pain_historical = /** @type {(inputs: Profile_Pain_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blessure passée, plus de douleur`)
};

const de_de2_profile_pain_historical = /** @type {(inputs: Profile_Pain_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frühere Verletzung, jetzt schmerzfrei`)
};

const it_it2_profile_pain_historical = /** @type {(inputs: Profile_Pain_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infortunio passato, ora niente dolore`)
};

/**
* | output |
* | --- |
* | "Past injury, no pain now" |
*
* @param {Profile_Pain_HistoricalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_pain_historical = /** @type {((inputs?: Profile_Pain_HistoricalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Pain_HistoricalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_pain_historical(inputs)
	if (locale === "es-419") return es_419_profile_pain_historical(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_pain_historical(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_pain_historical(inputs)
	if (locale === "de-DE") return de_de2_profile_pain_historical(inputs)
	if (locale === "it-IT") return it_it2_profile_pain_historical(inputs)
	return en_us2_profile_pain_historical(inputs)
});
export { profile_pain_historical as "profile.pain_historical" }